import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import { useDispatch } from 'react-redux';
import { GetSingleBank,UpdateBank } from '../store/slices/bankbook';
import { Getledgerdetail, Getledgergroups, GetState ,UpdateLedger} from '../store/slices/ledger'; 
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../common/Loader';
import GroupPopUp from '../common/GroupPopUp';
import AdminLayout from './AdminLayout';

const EditLedger = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ledgerId } = useParams(); 

  const [ledgerGroups, setLedgerGroups] = useState([]);
  const [state, setState] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
 

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;


  const [originalBankDetails, setOriginalBankDetails] = useState({
  type: 'Regular',
  account_no: '',
  bank_name: '',
  account_holder: '',
  ifsc: ''
});


  const [accountDetails, setAccountDetails] = useState({
    id:"",
    profile_id:id,
    ledger:"",
    group_id:'',
    is_default:"",
    opening_balance:"",
    dr_cr:"",
    type: 'Regular',
    account_no: '',
    bank_name: '',
    account_holder: '',
    ifsc: '',
    date: '',
    date_as_of: '',
    state: '',
    gstn: '',
    address: '',
    phone_number: '',
    opening_date:'',
    group_name:'',
    city: '',
    pin_code: ''
  });


   const [showPopup, setShowPopup] = useState(false);
  
    const handleOpenPopup = () => setShowPopup(true);
    const handleClosePopup = () => setShowPopup(false);

console.log(accountDetails)
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchLedgerGroups();
  }, [dispatch]);

   const fetchLedgerGroups = async () => {
    try {
      setIsLoading(true);
      const data = await dispatch(Getledgergroups()).unwrap();

      // Filter out groups where is_default == 1 (preserve non-default children)
      const isDefault = (val) => Number(val) === 1 || val === true || val === '1';
      const filterOutDefaultGroups = (groups = []) => {
        const result = [];
        (groups || []).forEach((grp) => {
          const filteredChildren = grp?.children ? filterOutDefaultGroups(grp.children) : [];
          if (!isDefault(grp?.is_default)) {
            result.push({ ...grp, children: filteredChildren });
          } else {
            // Skip default group, promote non-default children to current level
            result.push(...filteredChildren);
          }
        });
        return result;
      };

      const groupsArray = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);
      const filtered = filterOutDefaultGroups(groupsArray);
      setLedgerGroups(filtered);
    } catch (error) {
      console.error("Error fetching ledger groups:", error.message || error);
    } finally {
      setIsLoading(false);
    }
  };

const fetchSingleBank = async () => {
  try {
    setIsLoading(true);
    const data = await dispatch(GetSingleBank(ledgerId)).unwrap();
    const bankData = {
      type: data.data.type || 'Regular',
      bank_name: data.data.bank_name || '',
      account_no: data.data.account_no || '',
      account_holder: data.data.account_holder || '',
      ifsc: data.data.ifsc || '',
    };

    setAccountDetails((prevState) => ({
      ...prevState,
      ...bankData
    }));

    setOriginalBankDetails(bankData); // store original bank values

  } catch (error) {
    console.error("Error fetching bank details:", error.message || error);
  } finally {
    setIsLoading(false);
  }
};

  useEffect(() => {
    setIsLoading(true);
    dispatch(GetState())
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setState(data?.data);
      })
      .catch(({ message }) => {
        setIsLoading(false);
        alert(message);
      });
  }, [dispatch]);

  useEffect(() => {
    if (ledgerId) {
      setIsLoading(true);
      dispatch(Getledgerdetail({profile_id:id,ledger_id:ledgerId}))
        .unwrap()
        .then((data) => {
          setIsLoading(false);
          populateLedgerData(data?.ledger);
        })
        .catch(({ message }) => {
          setIsLoading(false);
          console.log(message)
        });
    }
  }, [dispatch, ledgerId]);

  const populateLedgerData = (data) => {
    setAccountDetails({
      ledger: data.ledger,
      group_name:data.group_name,
      group_id: data.group_id,
      opening_date: data.opening_date ? Moment(data.opening_date).format('YYYY-MM-DD') : '',
      dr_cr: data.dr_cr,
      is_default: data.is_default,
      account_no: data.account_no || '',
      bank_name: data.bank_name || '',
      account_holder: data.account_holder || '',
      ifsc: data.ifsc || '',
      state: data.state || '',
      gstn: data.gstn || '',
      address: data.address || '',
      phone_number: data.phone_number || '',
      opening_balance: parseFloat(data.opening_balance) || 0,
      city: data.city || '',
      pin_code: data.pin_code || '',
      type: data.type || 'Regular',
    });
      // ✅ If group_name is "Bank Accounts", call fetchSingleBank
  if (data.group_name === "Bank Accounts") {
    fetchSingleBank();
  }
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    if (name === 'group_name') {
      const groupId = value; // This is the selected group ID from the dropdown
      const groupName = findGroupNameById(ledgerGroups, groupId); // Find the group name by ID
  
      setAccountDetails((prevState) => ({
        ...prevState,
        group_id: groupId,
        [name]: groupName, // Save the group_name as well
      }));
    } else {
      setAccountDetails((prevState) => ({ ...prevState, [name]: value }));
    }
  
    setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };
  
  const findGroupNameById = (groups, groupId) => {
    for (let group of groups) {
      // Ensure both group.id and groupId are compared as strings
      if (group.id === groupId) {
        return group.group_name;
      }
  
      // Recursively search in child groups if available
      if (group.children && group.children.length > 0) {
        const foundGroupName = findGroupNameById(group.children, groupId);
        if (foundGroupName) {
          return foundGroupName;
        }
      }
    }
  
    return null;
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  let formErrors = {};

  if (!accountDetails.ledger?.trim()) formErrors.ledger = 'Ledger name is required';
  if (!accountDetails.group_id) formErrors.group_id = 'Group name is required';
  if (!accountDetails.dr_cr) formErrors.opening_balance = 'Transaction type is required';
  if (accountDetails.group_name === 'Bank Accounts') {
    if (!accountDetails.type) formErrors.type = 'Type is required';
    if (!accountDetails.account_no) formErrors.account_no = 'Account number is required';
    if (!accountDetails.ifsc) formErrors.ifsc = 'IFSC is required';
  }

  if (Object.keys(formErrors).length > 0) {
    setErrors(formErrors);
    return;
  }

  const ledgerData = {
    id: ledgerId,
    profile_id: id,
    group_id: accountDetails?.group_id,
    is_default: accountDetails?.is_default,
    ledger: accountDetails?.ledger,
    address: accountDetails?.address,
    phone_number: accountDetails?.phone_number,
    state: accountDetails?.state,
    gst_type: accountDetails?.type,
    gstn: accountDetails?.gstn,
    opening_balance: accountDetails?.opening_balance,
    dr_cr: accountDetails?.dr_cr,
    opening_date: accountDetails?.opening_date,
    city: accountDetails?.city,
    pin_code: accountDetails?.pin_code,
  };

  try {
    setIsLoading(true);

    // Step 1: Always update ledger
    await dispatch(UpdateLedger({ id: ledgerId, ...ledgerData })).unwrap();

    // Step 2: Check if bank-related fields changed
    if (accountDetails.group_name === "Bank Accounts") {
      const bankFields = ["type", "account_no", "bank_name", "account_holder", "ifsc"];

      const hasBankChanges = bankFields.some(
        (field) => accountDetails[field] !== originalBankDetails[field]
      );

      if (hasBankChanges) {
        await dispatch(UpdateBank({
          id: ledgerId,
          profile_id: id,
          type: accountDetails.type,
          account_no: accountDetails.account_no,
          bank_name: accountDetails.bank_name,
          account_holder: accountDetails.account_holder,
          ifsc: accountDetails.ifsc,
        })).unwrap();
      }
    }

    setIsLoading(false);
    alert("Ledger updated successfully!");
    navigate("/ledgerlist");

  } catch (error) {
    setIsLoading(false);
    alert("Failed to update ledger: " + error.message);
  }
};



  const renderOptions = (groups, level = 0) => {
    return groups.map((group) => (
      <React.Fragment key={group.id}>
        <option value={group.id}>
          {'\u00A0'.repeat(level * 4)} {group.group_name}
        </option>
        {group.children && group.children.length > 0 && renderOptions(group.children, level + 1)}
      </React.Fragment>
    ));
  };

  return (
    <AdminLayout>
          {isLoading && <Loader />}
            <div className="row content-body">
              <div className="container">
                <div className="page-header">
                  <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Ledger</h2>
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="#">Ledger</a>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Edit Ledger
                      </li>
                    </ol>
                  </div>
                  <div className="d-flex justify-content-end">
                    <button className="btn ripple btn-default" onClick={handleSubmit}>
                      Save
                    </button>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="card custom-card">
                      <div className="card-body">
                        <div className="form-group">
                          <div className="row">
                            <div className="col-md-3">
                              <label>
                                Name <span className="required">*</span>
                              </label>
                              <input name="ledger" type="text" placeholder="Enter the name" className="form-control" value={accountDetails?.ledger} onChange={handleInputChange} />
                              <p className="alert-message">{errors.ledger}</p>
                            </div>
                            <div className="col-md-3">
                              <div className="d-flex justify-content-between align-items-center">
                              <label>
                                Group Name <span className="required">*</span>
                              </label>
                               <a href='#' className="mb-2" onClick={handleOpenPopup} style={{ cursor: 'pointer', color: '#007bff' } }>
                                  Add Group
                                </a>
                               </div>
                              <select name="group_name" className="form-control" value={accountDetails?.group_id} onChange={handleInputChange}>
                                <option value="">Select</option>
                                {renderOptions(ledgerGroups)}
                              </select>
                              <p className="alert-message">{errors?.group_name}</p>
                            </div>
                            <div className="col-md-3">
                              <label>Opening Date</label>
                              <input name="opening_date" type="date" className="form-control" value={accountDetails?.opening_date} onChange={handleInputChange} />
                            </div>
                            <div className="col-md-3">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <label className="col-black mb-0">Amount</label>
                                <div className="ml-2">
                                  <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="dr_cr" id="credit" value="CR" checked={accountDetails?.dr_cr == 'CR'} onChange={handleInputChange} />
                                    <label className="form-check-label" htmlFor="credit">
                                      Cr
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="dr_cr" id="debit" value="DR" checked={accountDetails?.dr_cr == 'DR'} onChange={handleInputChange} />
                                    <label className="form-check-label" htmlFor="debit">
                                      Dr
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <input name="opening_balance" type="text" className="form-control" placeholder="Enter the amount" value={accountDetails?.opening_balance} onChange={handleInputChange} />
                              <p className="alert-message">{errors.opening_balance}</p>
                            </div>
                          </div>
                          { accountDetails?.group_name === 'Bank Accounts'? "" : (
                            <div className="row">
                            <div className="col-md-4">
                              <label>Address</label>
                              <input name="address" type="text" className="form-control" value={accountDetails?.address} onChange={handleInputChange} />
                            </div>
                             <div className="col-md-4">
                              <label>City</label>
                              <input name="city" type="text" className="form-control" value={accountDetails?.city} onChange={handleInputChange} />
                            </div>
                             <div className="col-md-4">
                              <label>Pin code</label>
                              <input name="pin_code" type="text" className="form-control" value={accountDetails?.pin_code} onChange={handleInputChange} />
                            </div>
                            <div className="col-md-4">
                              <label>Phone Number</label>
                              <input name="phone_number" type="text" className="form-control" value={accountDetails?.phone_number} onChange={handleInputChange} />
                            </div>
                            <div className="col-md-4">
                              <label>State</label>
                              <select className="form-control" name="state" value={accountDetails?.state || ''} onChange={handleInputChange}>
                                <option value="">--Select State--</option>
                                {(state || []).map((option, index) => (
                                  <option key={index} value={option?.state_name}>
                                    {option?.state_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-4">
                              <label>Gst Number</label>
                              <input name="gstn" type="text" placeholder="Enter the gstn" className="form-control" value={accountDetails?.gstn} onChange={handleInputChange} />
                            </div>
                          </div>

                          )}
                          

                          {/* Conditionally render additional fields */}
                          {/* parsedObject.group_name === 'Bank Accounts' && */}
                          {accountDetails?.group_name === 'Bank Accounts' && (
                            <div class="ledger_info row">
                              <div class="col-md-12">
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-md-2">
                                      <label class="rdiobox">
                                        <input name="type" type="radio" value="Regular" checked={accountDetails.type === 'Regular'} onChange={handleInputChange} /> <span>Regular</span>
                                      </label>
                                    </div>
                                    <div class="col-md-2">
                                      <label class="rdiobox">
                                        <input name="type" type="radio" value="OD/OCC" checked={accountDetails.type === 'OD/OCC'} onChange={handleInputChange} /> <span>OD/OCC</span>
                                      </label>
                                    </div>
                                  </div>
                                    <p className="alert-message">{errors.type}</p>
                                </div>

                                <div class="form-group">
                                  <div class="row">
                                    <div className="col-md-6">
                                      <label>
                                        Account No <span className="required">*</span>
                                      </label>
                                      <input name="account_no" type="text" className="form-control" placeholder="Enter account no" value={accountDetails.account_no} onChange={handleInputChange} />
                                      <p className="alert-message">{errors.account_no}</p>
                                    </div>
                                    <div className="col-md-6">
                                      <label>Bank Name</label>
                                      <input name="bank_name" type="text" className="form-control" placeholder="Enter bank name" value={accountDetails.bank_name} onChange={handleInputChange} />
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <div class="row">
                                    <div className="col-md-6">
                                      <label>Account Holder Name</label>
                                      <input
                                        name="account_holder"
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter account holder name"
                                        value={accountDetails?.account_holder}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <label>
                                        IFSC <span className="required">*</span>
                                      </label>
                                      <input name="ifsc" type="text" className="form-control" placeholder="Enter IFSC" value={accountDetails?.ifsc} onChange={handleInputChange} />
                                      <p className="alert-message">{errors.ifsc}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <GroupPopUp
                   show={showPopup}
        onClose={handleClosePopup}
        onSubmit={fetchLedgerGroups}
        />
          </AdminLayout>
  );
};

export default EditLedger;
